import React from 'react';
import request from 'arcdynamic-request';
import Alert from '../Alert';
import Input from '../Input';

export default class Login extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			error: null,
			isBusy: null,
			username: '',
			password: '',
		};

		this.login = this.login.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	login(e) {
		e.preventDefault();

		this.setState({
			isBusy: true,
			error: null,
		});

		request(arc.path.api, {
			service: 'arcimedes',
			action: 'Authentication.login',
			params: [this.state.username, this.state.password],
		}).then(res => {
			if (res && res.success) {
				this.props.setUser(true);

				this.setState({
					isBusy: null,
					error: null,
				})
			} else {
                this.props.setUser(false);
				this.setState({
					isBusy: null,
					error: res && res.message ? res.message : 'Unspecified error',
				})
			}
		});
	}

	handleChange(e) {
		this.setState({[e.currentTarget.name]: e.currentTarget.value});
	}

	render() {
		return (
			<div className='Login'>
				<div className='Login_body'>
					<form onSubmit={this.login}>
						<Input autocomplete='username' autoFocus={true} type='text' name='username' value={this.state.username} placeholder='Username' onChange={this.handleChange}/>
						<Input autocomplete='current-password' type='password' name='password' value={this.state.password} placeholder='Password' onChange={this.handleChange}/>
						<button data-busy={this.state.isBusy}>Login</button>
					</form>
					{
						this.state.error ? (
							<Alert type='error'>{this.state.error}</Alert>
						) : null
					}
				</div>
			</div>
		);
	}
}
